import React from 'react'
import PropTypes from 'prop-types'
import { Media, Row } from 'react-bootstrap'
import Image from 'components/image'

const AuthorByline = (props) => {
  var { author, className } = { ...props }

  let name = `${author.firstName} ${author.lastName}`
  if (!author.firstName && !author.lastName) {
    name = author.name
  }
  if (author.postnominals) {
    name += ` ${author.postnominals}`
  }
  let altText = `{name} {jobTitle}`

  return (
    <Row className={className}>
      <Media className="col-sm-12">
        <Media.Body>
          <h6 class="text-muted mts h7">By {name}</h6>
        </Media.Body>
      </Media>
    </Row>
  )
}

AuthorByline.propTypes = {
  author: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default AuthorByline
